import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.JensenIncomingCalls = routerStyxie({ actions: ['index', 'show']})
